import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Form, FormGroup, Breadcrumb, Button } from 'react-bootstrap'
import Select from 'react-select';
import Moment from 'moment';
import FontAwesome from 'react-fontawesome';
import CashflowStore from '../../stores/CashflowStore'
import CashFlowRecord from '../cashflow/CashFlowRecord'
import withSizes from 'react-sizes';
import ReportMobileTable from './ReportMobileTable'

const yTh = parseInt(Moment().format('YYYY')) + 543
class ReportCashFlowRecord extends Component {
  constructor(props) {
    super(props)

    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }

    this.state = {	 	
      loading:false,
      showTb:true,
      optionsYear:optionsYear,
      defaultYear:yTh,
      data:this.newEmptyRow(12),
      dataInfo:[],
      curInfo:false 
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.setState({loading:true})
    this.loadData(this.state.defaultYear)
  }

  componentWillReceiveProps(newProps){

  }

  newEmptyRow(number=1) {
    return new Array(number).fill(null).map((item,index)=>{
      return {month:(index+1),sum_spent:0,sum_received:0}
    })
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSumMoney(dataList,key) {
  let sum = 0
    dataList.forEach(function(item,index) {
      sum = parseFloat(item[key])+parseFloat(sum)
    })
    return sum
  }

  getSummary(key) {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      let value = item[key]
      value = (value===''||value===null||value===undefined||isNaN(value)?0:value)
      sum = parseFloat(value)+parseFloat(sum)
    })
    return sum
  } 

  getMonthText(month) {
    if (month==='1')
      return 'มกราคม'
    else if (month==='2')
      return 'กุมภาพันธ์'
    else if (month==='3')
      return 'มีนาคม'
    else if (month==='4')
      return 'เมษายน'
    else if (month==='5')
      return 'พฤษภาคม'
    else if (month==='6')
      return 'มิถุนายน'
    else if (month==='7')
      return 'กรกฎาคม'
    else if (month==='8')
      return 'สิงหาคม'
    else if (month==='9')
      return 'กันยายน'
    else if (month==='10')
      return 'ตุลาคม'
    else if (month==='11')
      return 'พฤศจิกายน'
    else if (month==='12')
      return 'ธันวาคม'
  }

  loadData(year) {
    CashflowStore.loadCashflowSummaryYearRecord(year-543,(result)=> {
      this.setState({data:result.data,loading:false})
    })
  }

  onYearChange(e) {
  	this.setState({defaultYear:e.value})
    this.loadData(e.value)
  }

  onRowSelect(year,month,e) {
  	this.setState({showTb:false})
    this.refs.cashFlowRecord.loadCashflowRecord(year,month,0,'')
    this.refs.cashFlowRecord.loadRecordCategory()
    this.refs.cashFlowRecord.loadCompany()
    this.refs.cashFlowRecord.setDateRange((year-543)+'-'+month,year,month)
  }

  onReportClose() {
    this.setState({showTb:true},()=>{
      this.loadData(this.state.defaultYear)
    })
  }

  loadDataInfo(year,month,rowSelect) {
    let {data,curInfo} = this.state
    let isInfo = false
    let indexInfo = ''
    data.forEach(function(item,index) {
      if (item.key==='info'&&index===rowSelect+1) {
        isInfo = true
        indexInfo = index
      } else if (item.key==='info'&&index!==rowSelect+1) {
        isInfo = 2
        indexInfo = index
      }
    })

    let i = 1
    if (rowSelect>indexInfo)
      i = 0

    if (isInfo===true) {
      data.splice(indexInfo, 1)
    } else if (isInfo===2) {
      if (data.splice(indexInfo, 1))
        data.splice(rowSelect+i, 0, {key:'info'})
    } else {
      data.splice(rowSelect+1, 0, {key:'info'})
    }

    if ((isInfo===2||isInfo===false)&&curInfo!==rowSelect) {
      CashflowStore.loadCashflowSummaryMonthRecord(year-543,month,(result)=> {
        this.setState({dataInfo:result.data})
      })  
    }
    this.setState({data:data,curInfo:rowSelect})
  }

  renderRowInfo(rindex) {
    let {dataInfo} = this.state
    if (dataInfo.length===0||dataInfo===undefined) {
      return(
        <tr key={'n-'+rindex}>
          <td colSpan={3} className='text-right'>ไม่พบข้อมูล</td>
          <td className='text-right'>-</td>
          <td className='text-right'>-</td>
          <td className='text-right'></td>
        </tr>
      )
    } else {
      return(
        dataInfo.map((item,index)=> {
          return(
            <tr key={index}>
              <td colSpan={3} className='text-right'>{item.category}</td>
              <td className='text-right'>{this.getNumberFormat(item.sum_received)}</td>
              <td className='text-right'>{this.getNumberFormat(item.sum_spent)}</td>
              <td className='text-right'></td>
            </tr>
          )  
        })  
      )
    }  
  }

  renderRowData() {
  	let {data,defaultYear} = this.state
    let isInfo = false
  	if (data.length===0) {
  		return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
  	}
  	return(
  	  data.map((item,index)=> {
        if (item.key==='info') {
          isInfo = true
          return this.renderRowInfo(index)
        }

  	  	return(
  	  	  <tr key={index}>
  	  	  	<td onClick={this.onRowSelect.bind(this,defaultYear,item.month)} className='text-center'>{isInfo?index:index+1}</td>
  	  	  	<td onClick={this.onRowSelect.bind(this,defaultYear,item.month)} className='text-center'>{this.getMonthText(item.month)}</td>
            <td className='text-center'><Button className='btn btn-sm btn-default' onClick={this.loadDataInfo.bind(this,defaultYear,item.month,index)}><FontAwesome name='info' />&nbsp;ดูข้อมูล</Button></td>
  	  	  	<td onClick={this.onRowSelect.bind(this,defaultYear,item.month)} className='text-right'>{this.getNumberFormat(item.sum_received)}</td>
  	  	  	<td onClick={this.onRowSelect.bind(this,defaultYear,item.month)} className='text-right'>{this.getNumberFormat(item.sum_spent)}</td>
  	  	  	<td onClick={this.onRowSelect.bind(this,defaultYear,item.month)} className='text-right'>{this.getNumberFormat(item.sum_received-item.sum_spent)}</td>
  	  	  </tr>
  	  	)
  	  })
  	)
  }

  renderTable() {
  	return(
  		<div className='table-responsive'>
  			<table className='table table-responsive table-hover table-bordered-solid table-tool' style={{marginBottom:'0'}}>
		        <thead>
		          <tr>
		            <th className='text-center' style={{ width: '30px' }}>ลำดับ</th>            
		            <th className='text-center' style={{ width: '80px' }}>เดือน</th>
                <th className='text-center' style={{ width: '150px' }}>ค่าใช้จ่ายตามหมวด</th>
		            <th className='text-center text-green' style={{ width: '150px' }}>ยอดรวมรายรับ / เดือน</th>
		            <th className='text-center text-red' style={{ width: '150px' }}>ยอดรวมรายจ่าย / เดือน</th>
		            <th className='text-center' style={{ width: '150px' }}>คงเหลือ</th>
		          </tr>  
		        </thead>
		        <tbody>
		          {this.renderRowData()}
		        </tbody>
		        <tfoot>
		          <tr>
		            <th className='text-center'>ลำดับ</th>
		            <th className='text-center'>เดือน</th>            
		            <th className='text-center'>ค่าใช้จ่ายตามหมวด</th>
		            <th className='text-right text-green'>{this.getNumberFormat(this.getSummary('sum_received'))}</th>
		            <th className='text-right text-red'>{this.getNumberFormat(this.getSummary('sum_spent'))}</th>
		            <th className='text-right'>{this.getNumberFormat(this.getSummary('sum_received')-this.getSummary('sum_spent'))}</th>
		          </tr>  
		        </tfoot>
		    </table>
  		</div>
  	)
  }

  onRowWorkClick(item,items) {
    let {defaultYear} = this.state
    this.onRowSelect(defaultYear,items.month)
  }

  renderMobileTable(){
    let {data,defaultYear} = this.state
    let _data = []
    _data = data.map((item,index)=>{
      let sum = (item.sum_received*1)-(item.sum_spent*1)
      return {month:item.month,month_text:this.getMonthText(item.month)+' พ.ศ. '+defaultYear,amount:sum.toString(),sum_received:'รายรับ '+this.getNumberFormat(item.sum_received),sum_spent:'รายจ่าย '+this.getNumberFormat(item.sum_spent)}
    })
    let fieldMap = {title:'month_text',amount:'amount',sub_title:'sum_received',date:'sum_spent',status:'',sub_status:''}
    return(
      <div>
        <ReportMobileTable
          itemlist={_data}
          fieldMap={fieldMap}
          keyIndex={'month'}
          onRowClick={this.onRowWorkClick.bind(this)}
        />
      </div>
    )
  }

  render() {
    let {loading,showTb} = this.state
    let {isMobile} = this.props
    return(
    	  <div>
          <div style={{display:(showTb?'':'none')}}>
            <Box loading={loading}>
              <Box.Header border={true}>
                <Box.Title>ตารางรายรับ-รายจ่าย</Box.Title>
                <Box.Tools>
                  
                </Box.Tools>
              </Box.Header>
              <Box.Body>
                <Form inline>
                  <FormGroup style={{marginBottom:'5px'}}>
                    <Select
                      clearable={false}
                      name="form-field-name"
                      value={ this.state.defaultYear }
                      options={this.state.optionsYear}
                      style={{ width: "80px" }}
                      onChange={ this.onYearChange.bind(this) }
                    />
                  </FormGroup>
                </Form>
                {isMobile?this.renderMobileTable():this.renderTable()}
              </Box.Body>                
            </Box>
          </div>  
	      	<div style={{display:(showTb?'none':'')}}>
            <Breadcrumb>
              <Breadcrumb.Item href="#" onClick={this.onReportClose.bind(this)}><FontAwesome name="table"/> ตารางรายรับ-รายจ่าย</Breadcrumb.Item>
              <Breadcrumb.Item href="#" active={true}>
                <FontAwesome name='file-o'/> รายการ
              </Breadcrumb.Item>            
            </Breadcrumb>
            <CashFlowRecord
              ref={'cashFlowRecord'}
              isReport={true}
              onReportClose={this.onReportClose.bind(this)}
            />
          </div>			      
	      </div>  
    )
  }
}

ReportCashFlowRecord.defaultProps = {
  
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
})

export default ReportCashFlowRecord = withSizes(mapSizesToProps)(ReportCashFlowRecord);


// WEBPACK FOOTER //
// ./src/view/report/ReportCashFlowRecord.js